import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./HomeCategory.css";
import { cartUtils, wishlistUtils } from "../utils/userCartWishlistUtils";
import ProgressLoader from "../Loader/ProgressLoader";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";

const Kalmainhome = () => {
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLoginAlert, setShowLoginAlert] = useState(false);
  const [cartCounts, setCartCounts] = useState({});
  const [wishlistStatus, setWishlistStatus] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (products.length > 0) {
      const initialCartCounts = {};
      const initialWishlistStatus = {};

      products.forEach((product) => {
        const cart = cartUtils.getCart();
        initialCartCounts[product.id] = cart[product.id] || 0;
        initialWishlistStatus[product.id] = wishlistUtils.isInWishlist(
          product.id
        );
      });

      setCartCounts(initialCartCounts);
      setWishlistStatus(initialWishlistStatus);
    }
  }, [products]);

  const fetchData = async () => {
    try {
      const subCatResponse = await axios.get(
        "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_SubCategory_SubCategoryList"
      );
      setSubCategories(subCatResponse.data?.reverse());
      const productsResponse = await axios.get(
        "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList"
      );
      setProducts(productsResponse.data?.reverse());
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleWishlistToggle = async (productId) => {
    if (wishlistStatus[productId]) {
      const success = await wishlistUtils.removeFromWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: false,
        }));
      }
    } else {
      const success = await wishlistUtils.addToWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: true,
        }));
      } else {
        setShowLoginAlert(true);
      }
    }
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };
  const handleSeeAllClick = (subCategoryId, subCategoryName) => {
    navigate(`/seeall/${subCategoryId}`, {
      state: {
        subCategoryName,
        categoryId: 1,
      },
    });
  };

  const productsBySubCategory = subCategories.reduce((acc, subCategory) => {
    const subCategoryProducts = products.filter(
      (product) => product.subCategoryId === subCategory.id
    );
    if (subCategoryProducts.length > 0) {
      acc[subCategory.id] = {
        name: subCategory.subCategoryName,
        products: subCategoryProducts,
      };
    }
    return acc;
  }, {});

  if (loading) {
    return (
      <>
      <div className="home-category-container">
        {[1, 2, 3].map((_, i) => (
          <div key={i} className="home-subcategory-section">
            
            <div className="subcategory-header">
              <div className="skeleton-shimmer skeleton-line medium" style={{ height: "20px" }}></div>
              <div className="skeleton-shimmer skeleton-line short" style={{ height: "20px" }}></div>
            </div>

            <div className="home-products-scroll-container">
              <div className="home-products-scroll">
                {Array(8).fill(0).map((_, idx) => (
                  <SkeletonLoader key={idx} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      </>
    );
  }

  return (
    <>
      <div className="home-category-container">
        {/* Featured Subcategories */}
        {Object.entries(productsBySubCategory).map(
          ([subCategoryId, { name, products }]) => (
            <div key={subCategoryId} className="home-subcategory-section">
              <div className="subcategory-header">
                <h2 className="home-subcategory-title">{name}</h2>
                <button
                  className="see-all-btn"
                  onClick={() => handleSeeAllClick(subCategoryId, name)}
                >
                  See All
                </button>
              </div>
              <div className="home-products-scroll-container">
                <div className="home-products-scroll">
                  {products.map((product) => (
                    <div key={product.id} className="home-product-card">
                      <div
                        className="product-image-container"
                        onClick={() => handleProductClick(product)}
                      >
                        <img
                          src={
                            product.productImage
                              ? `https://api.dremerz.net/uploads/${product.productImage}`
                              : "/default-product.jpg"
                          }
                          loading="lazy"
                          alt={product.brandName}
                          className="product-image"
                        />
                        {product.tags && (
                          <span className="product-tag">{product.tags}</span>
                        )}
                      </div>
                      <div className="product-info">
                        <h3 onClick={() => handleProductClick(product)} className="m-0 home-product-brandname">
                          {product.brandName}
                        </h3>
                        <p className="home-product-name m-0">{product.productName}</p>
                        <div className="home-product-price m-0">
                          <span className="home-current-price">
                            ₹{product.sellingPrice}
                          </span>

                          {product.originalPrice && (
                            <>
                              <span className="home-original-price">
                                ₹{product.originalPrice}
                              </span>
                              <span className="home-offer">
                                 {" "}({Math.round(
                                  ((product.originalPrice -
                                    product.sellingPrice) /
                                    product.originalPrice) *
                                    100
                                )}
                                % OFF)
                              </span>
                            </>
                          )}
                        </div>

                        <div className="home-product-actions">
                          <button
                            className={`home-action-btn home-wishlist-btn ${
                              wishlistStatus[product.id]
                                ? "home-in-wishlist"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleWishlistToggle(product.id);
                            }}
                          >
                            {wishlistStatus[product.id] ? (
                              <FaHeart />
                            ) : (
                              <FaRegHeart />
                            )}

                            {wishlistStatus[product.id]
                              ? " Wishlisted"
                              : " Wishlist"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
      {showLoginAlert && (
        <div className="home-modal-overlay">
          <div className="home-modal-content">
            <h3>Login Required</h3>
            <p>Please login to add items to your cart or wishlist.</p>
            <div className="home-modal-actions">
              <button
                className="btn-cancel"
                onClick={() => setShowLoginAlert(false)}
              >
                Cancel
              </button>
              <button className="btn-login" onClick={() => navigate("/login")}>
                Login
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Kalmainhome;
